import { CareerSiteLanguageType } from '@locale/locale-store';

import { Job } from 'types/jobs';

export const getMissingJobPostingTranslations = (job: Job, languages: CareerSiteLanguageType[]) => {
  const missingTranslations: { [key in CareerSiteLanguageType]?: boolean } = {};
  languages.forEach((language) => {
    const jobLanguage = job.languages.find((l) => l.language === language);
    missingTranslations[language] =
      !jobLanguage ||
      !jobLanguage.title ||
      !jobLanguage.description ||
      !jobLanguage.shortDescriptionHtml;
  });
  return missingTranslations;
};

export const getMissingApplicationFormTranslations = (
  job: Job,
  languages: CareerSiteLanguageType[],
) => {
  const missingTranslations: { [key in CareerSiteLanguageType]?: boolean } = {};
  const hasQuestions = job?.languages.some((l) => l.form.sections[0].questions.length > 0);
  if (!hasQuestions) {
    languages.forEach((language) => {
      missingTranslations[language] = false;
    });
    return missingTranslations;
  }
  if (languages.length > 1) {
    languages.forEach((language) => {
      const jobLanguage = job?.languages.find((l) => l.language === language);
      const questions = jobLanguage?.form.sections[0].questions ?? [];
      let missingTranslationsInLanguage = questions.some((question) => {
        const hasOptions = Boolean(question.options);
        if (!question.title) {
          return true;
        }
        if (hasOptions) {
          return question.options.some((option) => !option.display);
        }
        return false;
      });
      if (hasQuestions && questions?.length === 0) {
        missingTranslationsInLanguage = true;
      }
      missingTranslations[language] = missingTranslationsInLanguage;
    });
  }
  return missingTranslations;
};
